import './FAQsListSkeleton.scss';

const FAQsListSkeleton = () => {

  return (
    <div className="faqs__section__skeleton">
      {[...Array(10)].map((_, index) => (
        <div key={index} className="faq__item__skeleton">
          <div className='faq__question__skeleton'></div>
          <span className="faq__arrow__skeleton"></span>
        </div>
      ))}
    </div>
  )
};

export default FAQsListSkeleton;